import Vue from 'vue'
import { callTurnToConfigFn } from 'util/turnto-utils'
import galleryConfig from './gallery-widget.config'
import galleryStore from 'store/gallery-widget-store'
import Gallery from 'components/gallery/gallery'

import withRender from './gallery-widget.html'

export default withRender(Vue.extend({
  data() {
    return {
      galleryConfig,
      galleryStore
    }
  },
  components: { 'tt-gallery': Gallery },
  computed: {
    skus() {
      return this.galleryStore.skus
    },
    tags() {
      return this.galleryStore.tags
    }
  },
  methods: {
    onFinish() {
      callTurnToConfigFn('gallery', 'onFinish')
    }
  }
}))
